import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {TypedSimpleChanges} from '../../../../../../common/typed-on-changes';
import {Widget} from '../../../../../../components/layout/widget/widget';
import {
    createWHeaderTitlePartText,
    W_HEADER_TITLE_PART_SYMBOL_TYPE,
    W_HEADER_TITLE_PART_TEXT_TYPE,
    WHeaderTitlePartText
} from './parts';
import {
    W_HEADER_TITLE_PART_GROUP_SHARED_TYPE
} from './parts/w-header-title-part-group-shared/w-header-title-part-group-shared';
import {WidgetHeaderTitlePart} from './widget-header-title';

const DEFAULT_TITLE$ = of('');

@Component({
    selector: 'widget-header-title',
    templateUrl: './widget-header-title.component.html',
    styleUrls: ['./widget-header-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WidgetHeaderTitleComponent implements OnInit, OnChanges {

    @Input()
    public widget: Widget;

    public titleParts$: Observable<WidgetHeaderTitlePart[]>;

    public readonly partTypeText = W_HEADER_TITLE_PART_TEXT_TYPE;
    public readonly partTypeSymbol = W_HEADER_TITLE_PART_SYMBOL_TYPE;
    public readonly partTypeGroupShared = W_HEADER_TITLE_PART_GROUP_SHARED_TYPE;

    constructor(
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        this.updateParts();
    }

    public ngOnChanges(changes: TypedSimpleChanges<WidgetHeaderTitleComponent>): void {
        if (changes.widget) {
            this.updateParts();
        }
    }

    public updateParts(): void {
        const widget: Widget = this.widget;
        const implInstance = widget && widget.implementationInstance;

        const widgetTitleParts$ = implInstance && implInstance.titleParts$;

        const getWidgetTitleStream = (): Observable<string> =>
            widget && widget.title$ || DEFAULT_TITLE$;

        this.titleParts$ = widgetTitleParts$
            || getWidgetTitleStream().pipe(
                map<string, WHeaderTitlePartText[]>(title => [
                    createWHeaderTitlePartText(title)
                ])
            );

        this.changeDetectorRef.markForCheck();
    }

}
